import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MessageSquare, Mail } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

/**
 * Shared closing CTA block for inner pages. Uses `on-dark` to invert button alt color.
 */
export const ClosingCTA = ({
    eyebrow,
    title,
    lead,
    testId = "closing-cta",
}) => {
    const { t, waUrl } = useLang();
    const copy = {
        eyebrow: eyebrow || t.closing.eyebrow,
        title: title || t.closing.title,
        lead: lead || t.closing.lead,
    };

    return (
        <section
            className="sec ink on-dark pt-grain relative overflow-hidden"
            data-testid={testId}
        >
            <div className="wrap relative z-10 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="pt-eyebrow mb-5 justify-center">
                        <span className="dot" />
                        <span>{copy.eyebrow}</span>
                    </div>
                    <h2 className="h2 mx-auto max-w-[20ch] text-white">
                        {copy.title}
                    </h2>
                    <p className="lead mx-auto mt-4 max-w-[54ch] text-[#C5CDD8]">
                        {copy.lead}
                    </p>
                    <div className="mt-10 flex flex-wrap justify-center gap-3">
                        <a
                            href={waUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pt-btn"
                            data-testid={`${testId}-wa`}
                        >
                            <MessageSquare size={18} />
                            {t.common.ctaWhatsapp}
                        </a>
                        <Link
                            to="/contacto"
                            className="pt-btn alt"
                            data-testid={`${testId}-contact`}
                        >
                            <Mail size={16} />
                            {t.common.ctaContact}
                        </Link>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
